import { Fab } from '@mui/material';
import { styled } from '@mui/system';

const AddPropertyButton = styled(Fab)(({ theme }) => ({
    background: 'rgba(235, 235, 235, 0.4)',
    color: '#000',
    borderRadius: 0,
    width: '100%',
    minHeight: '200px',
    height: '100%',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
        background: 'rgba(235, 235, 235, 0.2)',
        color: theme.palette.primary.main,
        '& svg': {
            fill: theme.palette.primary.main,
        },
    },
    '& svg': {
        fontSize: 92,
        fill: '#757575',
        margin: 0,
        display: 'block',
    },
}));

export default AddPropertyButton;
